<template>
      <div class="product-selector-info deal-info">
    <div class="section-heading">
      <h3>Deal Info</h3>
    </div>

    <div class="top">
      <a class="badge badge-primary clear-all" @click="toggle_block=true" v-if="hasExtras">
        Clear All
        <span class="fa fa-trash"></span>
      </a>
      <div class="col col-12 info-item price">
        <div class="row">
          <div class="col col-xs-12">
            <label>
              Pay R{{ currentTotalPrice }}
              <span>/month</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom deal-details">
      <div class="col col-12 info-item sim-info extra" v-if="!isEmpty(currentSim.deal)">
        <div class="sim">
          <label
            class="activation-badge d-block badge badge-primary"
            v-if="currentSim.iccid != ''"
          >Activation</label>
          <label>
            {{ currentSim.deal.display_details.name }}
            <span
              v-if="currentSim.deal.display_details.description != ''"
            >/includes</span>
          </label>
          <div class="included" v-html="currentSim.deal.display_details.description"></div>
        </div>
      </div>
      <div class="col col-12 info-item data-info extra-reccuring no-option" v-if="hasExtras">
        <div class="row">
          <div class="col col-xs-12">
            <label>Extra Recurring Bundles</label>
          </div>
        </div>
      </div>

      <div
        class="col col-12 info-item data-info"
        v-bind:class="{'no-option': currentSim.data == null}"
        v-if="!isEmpty(currentSim.data)"
      >
        <div class="row">
          <div class="col col-xs-12">
            <label>{{ currentSim.data.name + " DATA" }}</label>
          </div>
        </div>
      </div>

      <div
        class="col col-12 info-item mins-info"
        v-bind:class="{'no-option': currentSim.mins == null}"
        v-if="!isEmpty(currentSim.mins)"
      >
        <div class="row">
          <div class="col col-xs-12">
            <label>{{ currentSim.mins.name + " MINS" }}</label>
          </div>
        </div>
      </div>

      <div
        class="col col-12 info-item sms-info"
        v-bind:class="{'no-option': currentSim.sms == null}"
        v-if="!isEmpty(currentSim.sms)"
      >
        <div class="row">
          <div class="col col-xs-12">
            <label>{{ currentSim.sms.name + " SMS's" }}</label>
          </div>
        </div>
      </div>

      <div class="col col-12 info-item whatsApp-info" v-if="!isEmpty(currentSim.whatsApp)">
        <div class="row">
          <div class="col col-xs-12">
            <!-- <label>WhatsApp 123</label> -->
            <label>{{ currentSim.whatsApp.name + " WHATSAPP " }}</label>
            <button type="button" class="close" aria-label="Close">
              <span aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="col col-12 info-item sms-info"
        mask="### ### ####"
        v-if="!isEmpty(currentSim.subscriber) && currentSim.subscriber.port_number"
      >
        <div class="row">
          <div class="col col-xs-12">
            <label>PORT NUMBER: {{ currentSim.subscriber.number_to_port }}</label>
          </div>
        </div>
      </div>
    </div>
    <vue-block :classname="'align-items-center justify-content-center'" :toggle.sync="toggle_block">
      <div class="remove-container">
        <h4>Clear your deal?</h4>
        <div>
          <button class="btn btn-outline-light btn-sm" @click="clearCurrentDeal">Yes</button>
          <button class="btn btn-outline-light btn-sm" @click="toggle_block = !toggle_block">No</button>
        </div>
      </div>
    </vue-block>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from "@/components/shared/event-bus";

export default {
  name: "vue-deal-info",
  computed: {
    ...mapGetters(["currentTotalPrice", "currentSim"]),
    hasExtras() {
      var self = this;
      return (
        !self.isEmpty(self.currentSim.data) ||
        !self.isEmpty(self.currentSim.mins) ||
        !self.isEmpty(self.currentSim.sms) ||
        !self.isEmpty(self.currentSim.whatsApp)
      );
    }
  },
  props: ["builder"],
  data() {
    return {
      toggle_block: false
    };
  },
  methods: {
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    clearCurrentDeal: function() {
      var self = this;
      self.toggle_block = false;
      EventBus.$emit("clear:current-item");
    }
  }
};
</script>